module.exports = __webpack_public_path__ + "static/AccountInfo-0990021c00846b4a235c03233ba885e7.png";